import { gql } from '@apollo/client'
import { useCleanFilterForRequest, useSearch, useSort } from '@btime/react-contexts'
import React from 'react'

import { placesClient } from '../../../../utils/apollo/api'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../components/helpers/LazyAction'
import StatePresenter from '../../../../components/helpers/StatePresenter'
import useRouteParams from '../../../../utils/routes/helpers/useParam'

const Context = React.createContext()
const { Provider } = Context
export const usePlaceLevelsState = () => React.useContext(Context) || {}
export const usePlaceLevels = () => usePlaceLevelsState()?.placeLevels || []

const QUERY = gql`
  query PlaceLevels($page: Int, $search: String, $sort: [PlaceLevelSort], $filter: PlaceLevelFilter) {
    placeLevels(page: $page, search: $search, sort: $sort, filter: $filter) {
      id
      name
      resume
      type
    }
  }
`

const PlaceLevelsLoader = ({ children, uncontrolledChildren }) => {
  const { field, type } = useSort()
  const search = useSearch()
  const filter = useCleanFilterForRequest()
  const placeType = useRouteParams('type')

  const { data, fetchMore, variables, done, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      search,
      sort: { field: field || 'NAME', type },
      filter: { ...filter, types: placeType }
    },
    client: placesClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
      </StatePresenter>
      <LazyAction action={fetchMore} waiting={state.loading || state.isFetchingMore} disabled={done} />
    </Provider>
  )
}

export default PlaceLevelsLoader
